import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ItemsCarousel from 'react-items-carousel';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const getProductId = (product) => product._id || product.productID;

export const MotorplayPlanCarousel = ({
  products = [],
  numberOfCards = 2,
  renderCard,
}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [expandedDescriptionCardId, setExpandedDescriptionCardId] = useState(null);

  const safeActiveItemIndex = useMemo(() => {
    const total = products.length;
    if (total <= 0) return 0;
    return Math.min(Math.max(0, activeItemIndex), total - 1);
  }, [activeItemIndex, products.length]);

  useEffect(() => {
    setExpandedDescriptionCardId(null);
  }, [safeActiveItemIndex]);

  useEffect(() => {
    const total = products.length;
    if (total > 0 && activeItemIndex > total - 1) {
      setActiveItemIndex(total - 1);
    }
  }, [activeItemIndex, products.length]);

  return (
    <div
      className='selectAddOnCarousel'
      style={{ width: (products.length === 1 && numberOfCards !== 1) ? '30%' : '100%', margin: '0 auto' }}
    >
      <ItemsCarousel
        slidesToScroll={1}
        infiniteLoop={false}
        gutter={10}
        activePosition='center'
        disableSwipe={false}
        alwaysShowChevrons={false}
        numberOfCards={products.length > 1 ? numberOfCards : 1}
        showSlither={false}
        activeItemIndex={safeActiveItemIndex}
        requestToChangeActive={(value) => setActiveItemIndex(value)}
        rightChevron={
          <div className='chevron chevron--right'>
            <div className='chevron__icon text-white'>
              <FaChevronRight size={50} />
            </div>
          </div>
        }
        leftChevron={
          <div className='chevron chevron--left'>
            <div className='chevron__icon text-white'>
              <FaChevronLeft size={50} />
            </div>
          </div>
        }
      >
        {products.map((product) => {
          const productId = getProductId(product);

          return renderCard({
            product,
            productId,
            isDescriptionExpanded: expandedDescriptionCardId === productId,
            onDescriptionExpandChange: (expanded) => {
              setExpandedDescriptionCardId(expanded ? productId : null);
            },
          });
        })}
      </ItemsCarousel>
    </div>
  );
};

MotorplayPlanCarousel.propTypes = {
  products: PropTypes.array,
  numberOfCards: PropTypes.number,
  renderCard: PropTypes.func.isRequired,
};
